import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

/**
 * Placeholder view for the upcoming Automations feature.
 *
 * Rendered in the fullpage chat main panel when the "Automations" tab is selected.
 * This is intentionally a static empty state for now — the real automations UI is
 * built into this shell in a follow-up, so the surrounding sidebar/tab wiring can
 * land first.
 */
@Component({
  selector: 'agent-automations-placeholder',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="automations-placeholder">
      <div class="automations-icon">
        <i class="fa-regular fa-bolt"></i>
      </div>
      <span class="automations-title">Automations</span>
      <span class="automations-subtitle">Set up automated workflows for Workbuddy Agent. This is coming soon.</span>
    </div>
  `,
  styleUrls: ['./automations.placeholder.component.less'],
})
export class AgentAutomationsPlaceholderComponent {}
